import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
  VStack
} from '@chakra-ui/react';
import MainLayout from 'components/layouts/MainLayout';
import { openWindow } from 'libs/line';
import { tenantConfigurationAtom } from 'libs/recoil/atom';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

export const LINK_SUCCESS_PAGE_PATH = '/smart-receipt/success';

export const LinkSuccessPage: FC = () => {
  const tenantConfig = useRecoilValue(tenantConfigurationAtom);
  const navigate = useNavigate();

  const handleOpenSmartReceipt = () => {
    if (tenantConfig.smart_receipt?.login_url) {
      openWindow(tenantConfig.smart_receipt.login_url);
    }
  };

  const handleGoToTop = () => {
    navigate('/membership');
  };

  return (
    <MainLayout pageTitle="連携完了" bg="dark.50" header footer>
      <Container px="1rem" pt="2.25rem">
        <Flex direction="column" align="center" justify="center">
          <VStack textAlign="center">
            <Box mb={10} width="100%" maxWidth="400px">
              <Heading as="h1" size="lg" color="gray.700" mt={3} mb={10}>
                スマートレシートを連携しました
              </Heading>

              <Text fontSize="1rem" lineHeight="1.5" color="gray.500">
                お買い物時に会員番号を提示すると、
                <br />
                自動でスマートレシートに明細が記録されます。
              </Text>
            </Box>

            <Box mb={10} width="100%" maxWidth="400px">
              <Button
                variant="primary-fullwidth-rounded"
                size="lg"
                onClick={handleOpenSmartReceipt}
                mb={4}
              >
                スマートレシートを開く
              </Button>

              <Button
                variant="primary-outline-fullwidth-rounded"
                size="lg"
                onClick={handleGoToTop}
              >
                トップに戻る
              </Button>
            </Box>
          </VStack>
        </Flex>
      </Container>
    </MainLayout>
  );
};
